/* eslint-disable react/prop-types */
import { Row, Col, DatePicker, Button, Space, Form } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { add, remove, get, update } from 'helpers/QueryHelper';
import React from 'react';
import moment from 'moment';
import notificationWithIcon from 'components/Notification/notificationWithIcon';
import PropTypes from 'prop-types';
// import data from './data';
import exercise from './exerciseSkills';

const changeColors = (index) => {
  const color = ['#FD9726', '#2ACFD3', '#F24422', '#7A57CE', '#8BC427', '#00A1DE'];
  let newIndex = index;
  while (newIndex > color.length - 1) newIndex -= color.length;
  return color[newIndex];
};

function ListTopics({ classFields, unit }) {
  const [data, setData] = React.useState(null);
  const [form] = Form.useForm();
  const getData = async () => {
    const res = await get('Examinations', '*', { grade: 2, unit: 4 }, 'SortOrder ASC', 'METADATA');
    setData(res);
  };
  const onFinish = async (index, item) => {
    const value = form.getFieldValue(`date${index}`);
    if (value) {
      const response = await get('Assignments', '*', { classId: id, examId: item.id }, 'id', 'CLASSWORK');
      // tìm số lần cuối cùng được giao của đề bị trùng
      const count = response[0]?.title.match(/(\d+)(?!.*\d)/g);
      const { id, teacherId, className } = classFields;
      const initialValues = {
        title: `Đề kiểm tra tiến độ ${index + 1} - Unit ${unit} (lần ${count ? +count + 1 : 1})`,
        instructions: '',
        color: 'black',
        assignmentType: 'ASSIGNMENT',
        points: 10,
      };
      const parameters = {
        ...initialValues,
        dueDate: moment.isMoment(value) ? value.format('YYYY-MM-DD HH:mm:ss') : null,
        assignmentType: 'ASSIGNMENT',
        classId: id,
        createdBy: teacherId,
        examId: item.id,
        settings: JSON.stringify({ tags: 'UNIT' }),
      };
      // remove('Assignments', '04aeba86-9702-4abf-a261-dcd5e2dd53c8', 'CLASSWORK');

      // if (response.length > 0) {
      //   await update('Assignments', response[0].id, parameters, 'CLASSWORK');
      // } else {
      await add('Assignments', parameters, 'CLASSWORK');
      // }
      notificationWithIcon('success', 'Thông báo', 'Giao bài thành công.');
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  if (!data) return '';

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      {data.map((item, index) => (
        <Form key={item.id} form={form} layout='vertical'>
          <div className='exercise-card d-flex justify-content-center my-3'>
            <div className='d-flex flex-grow-1 bg-white' style={{ maxWidth: 850, borderRadius: 5, border: `1px solid ${changeColors(index)}` }}>
              <div
                style={{
                  minWidth: 50,
                  color: 'white',
                  textAlign: 'center',
                  background: `${changeColors(index)}`,
                  position: 'relative',
                }}
              >
                <div style={{ fontSize: 28, fontWeight: 700, font: '700 "Trebuchet MS",sans-serif', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>{index + 1}</div>
              </div>
              <div className='d-flex flex-grow-1 align-items-center'>
                <Row className='flex-grow-1 py-2 px-3'>
                  <Col xs={24} sm={24} md={16}>
                    <div className='d-flex flex-grow-1'>
                      <div style={{ flex: 1, fontSize: 25, color: `${changeColors(index)}` }}>{`Đề số ${index + 1}`}</div>
                      <Button type='dashed' shape='circle' className='d-block d-md-none' style={{ background: `${changeColors(index)}`, color: 'white', marginRight: 15, height: 'fit-content', fontWeight: 600 }}>
                        <i className='fa fa-pen-square' />
                      </Button>
                    </div>
                    <span style={{ color: 'rgba(0,0,0,0.6)' }}>Loại bài làm: </span>
                    {exercise.skills.map((v, i) => {
                      const isLast = exercise.skills.length - 1 !== i;
                      return (
                        <React.Fragment key={v.id}>
                          <span>{v.visible && v.name}</span>
                          {v.visible && isLast && <span style={{ color: `${changeColors(index)}` }}> | </span>}
                        </React.Fragment>
                      );
                    })}
                  </Col>
                  <Col xs={24} sm={24} md={8} style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item name={`date${index}`} requiredMark={false} style={{ margin: 0 }}>
                      <DatePicker
                        disabledDate={(current) => {
                          return current && current < moment().endOf('day');
                        }}
                        placeholder='Ngày nộp bài'
                        showTime
                        format='DD/MM/YYYY HH:mm'
                        getPopupContainer={(trigger) => {
                          return trigger.parentElement;
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  onClick={() => {
                    onFinish(index, item);
                  }}
                  key='Assignment'
                  // type='primary'
                  icon={<FileTextOutlined />}
                  className='px-3 py-2 d-none d-md-block'
                  style={{ backgroundColor: `${changeColors(index)}`, color: 'white', marginRight: 15, height: 'fit-content' }}
                >
                  Giao bài
                </Button>
              </div>
            </div>
          </div>
        </Form>
      ))}
    </Space>
  );
}

export default ListTopics;

ListTopics.propTypes = {
  unit: PropTypes.number,
};

ListTopics.defaultProps = {
  unit: 0,
};
